import { AuthActions } from '@portal/actions';
import CreateNewPassword from '@portal/components/CreateNewPassword/CreateNewPassword';
import { getRouteStackPath } from '@portal/config/routes';
import useReduxState from '@portal/hooks/useReduxState';
import { UserCredentialType } from '@portal/models/enumerators/auth';
import { translate } from '@portal/services/i18n';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  checkPasswordValidation,
  validatePassword,
} from '@portal/utils/validate';
import AdvancedHeader from '@portal/components/AdvancedHeader/AdvancedHeader';
import AdvancedPanelContentHeader from '@portal/components/AdvancedPanelContentHeader/AdvancedPanelContentHeader';
import AdvancedCard from '@portal/components/AdvancedCard/AdvancedCard';
import { useNavigation } from '@portal/hooks/useNavigation';

const AlterPassword = () => {
  const {
    auth: { changeUserCredential, changeUserCredentialFail },
  } = useReduxState();

  const navigate = useNavigation();
  const dispatch = useDispatch();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [passwordValidation, setPasswordValidation] = useState(
    validatePassword(password)
  );

  const onChangePassword = (value: string) => {
    const validate = validatePassword(value);

    setPasswordValidation(validate);
    setPassword(value);
  };

  const handleSubmit = () => {
    const requestData: models.UpdateUserCredentialRequest = {
      type: UserCredentialType.PASSWORD,
      credential: password,
      token,
    };

    if (checkPasswordValidation(validatePassword(password))) {
      dispatch(AuthActions.userCredentialChangeCredential(requestData));
    }
  };

  useEffect(() => {
    if (navigate && navigate.location.state) {
      setToken(navigate.location.state as string);
    }
  }, [navigate]);

  useEffect(() => {
    if (changeUserCredentialFail) {
      navigate('/minha-conta');
    }

    dispatch(AuthActions.userCredentialError(null));
  }, [changeUserCredentialFail, dispatch, history]);

  useEffect(() => {
    if (changeUserCredential) {
      navigate(getRouteStackPath('PROFILE', 'PROFILE_PAGE'));

      dispatch(AuthActions.userCredentialSuccess(false));
    }
  }, [changeUserCredential, dispatch, history]);

  return (
    <>
      <AdvancedHeader
        showBreadCrumbs
        breadCrumbs={[
          {
            active: true,
            title: translate('COMPONENTS.BREADCRUMB.HOME'),
            url: `${getRouteStackPath('HOME', 'HOME_PAGE')}`,
          },
          {
            active: true,
            title: translate('COMPONENTS.BREADCRUMB.MY_ACCOUNT'),
            url: getRouteStackPath('PROFILE', 'PROFILE_PAGE'),
          },
          {
            active: false,
            title: translate('PAGES.MY_ACCOUNT.TABS.CHANGE_PASSWORD_STACK'),
          },
        ]}
      />
      <div className="alter-password">
        <AdvancedPanelContentHeader
          testId="alter-password-header"
          title={translate('PAGES.MY_ACCOUNT.TABS.CHANGE_PASSWORD_STACK')}
          description={translate(
            'PAGES.MY_ACCOUNT.DESCRIPTIONS.CHANGE_PASSWORD_STACK'
          )}
          goBackAction={() => navigate.back()}
        />
        <AdvancedCard testId="alter-password-card">
          <CreateNewPassword
            password={password}
            setPassword={onChangePassword}
            passwordValidation={passwordValidation}
            setPasswordValidation={setPasswordValidation}
            checkPasswordValidation={checkPasswordValidation}
            loading={false}
            handleSubmit={handleSubmit}
            title={translate('PAGES.MY_ACCOUNT.DESCRIPTIONS.NEW_PASSWORD')}
          />
        </AdvancedCard>
      </div>
    </>
  );
};

export default AlterPassword;
